import { createActionGroup, props } from "@ngrx/store";
import { FullUserFragment, ListUsersQuery, UpdateJobMutation } from "graphql.generated";
import { JobRole } from "src/app/global.constants";
import { ActionSource } from "src/app/state/action-sources";

export const JobAgentActions = createActionGroup({
  source: ActionSource.JOB_AGENT,
  events: {
    'Employee Autocomplete Input Changed': props<{
      value: string;
      role: JobRole;
    }>(),
    'Employee Autocomplete Search Fired': props<{
      query: string;
      role: JobRole;
    }>(),
    'Search Employees Success': props<{ employees: ListUsersQuery['usersv2']['users'] }>(),
    'Employee Loaded': props<{ employee: FullUserFragment; role: JobRole }>(),
    'Employee Selected': props<{ employee: FullUserFragment; role: JobRole }>(),
    'Clicked Outside': props<{ role: JobRole }>(),
    'Change Agent Menu Item Clicked': props<{ role: JobRole }>(),
    'Unassign Agent Menu Item Clicked': props<{ role: JobRole }>(),
    'Agent Name Clicked': props<{ userId: string }>(),
    'Add Agent Button Clicked': props<{ role: JobRole }>(),
    'Assign Agent Success': props<{
      updatedJob: UpdateJobMutation['updateJobs']['jobs'][number];
      customSuccessMessage?: string;
    }>(),
    'Assign Agent Error': props<{ error: Error }>(),
    'Unassign Agent Success': props<{
      updatedJob: UpdateJobMutation['updateJobs']['jobs'][number];
      customSuccessMessage?: string;
    }>(),
    'Unassign Agent Error': props<{ error: Error }>(),
    'Add Myself Button Clicked': props<{ role: JobRole }>(),
  },
});
